// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
    height: 100%;
    width: 100%;
    margin: 0;
}

body>div {
    display: none;
    /* background-image: radial-gradient(circle farthest-side, #fceabb, #f8b500); */
    /* background-image: radial-gradient(circle farthest-side, #ff512f, #f09819); */
    /* color: black; */
    /* font-family: Arial, Helvetica, sans-serif; */
    /* background-color: white; */
}

body,
button {
    background-color: black;
    color: white;
    font-family: 'Courier New', Courier, monospace;
}

header span, button {
    width: 6em;
    padding: 1px 4px;
}

header span {
    font-size: 100px;
    text-align: center;
}

button {
    border: none;
    font-weight: 500;
    cursor: pointer;
}

.hover, button:hover {
    font-weight: 900;
}

button:active {
    transform: translate(1px, 1px);
}

header button:last-child {
    border: 1px solid white;
    padding: 10px;
    border-radius: 10px;
}

header button:last-child:hover {
    border: 2px solid white;
}

header {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 0;
    height:5em;
}

canvas {
    height: 100%;
    width: 100%;
    z-index: -1;
    position: fixed;
}

.content {
    margin: 0 5% 20px 5%;
    border: 1px solid white;
    padding: 2em;
}

p {
    line-height: 1.3;
}

li p {
    margin-left: 3em;
    margin-top: 0;
}

li div:first-child {
    display: flex;
    align-items: baseline;
    gap: 1em;
}

li h3 {
    margin-bottom: 0;
    /* color: white; */
}

/* ul a:first-child {
    color: white;
} */

ul a {
    color: #41FF00;
}

div:nth-of-type(1) li::marker {
    color: white;

}

li div{
    margin-bottom: 1em;
}

div:nth-of-type(2) ul {
    list-style: none;
}

#copy {
    display: flex;
    justify-content: center;
    align-content: center;
    background-color: transparent;
    border-radius: 5px;
    height: fit-content;
    width: fit-content;
}

#copy img {
    height: 1em;
    width: 1em;
}

div:nth-of-type(2) li {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 2em;
    font-size: larger;
}

li span {
    display: none;
    font-style: italic;
    font-weight: 300;
} 

div:nth-of-type(3) p {
    text-indent: 2em;
}

@media screen and (min-width: 500px) {
    button {
        font-size: 1.5em;
    }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;IAEI,YAAY;IACZ,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,+EAA+E;IAC/E,+EAA+E;IAC/E,kBAAkB;IAClB,+CAA+C;IAC/C,6BAA6B;AACjC;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;GAEG;;AAEH;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;;AAEhB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["html,\r\nbody {\r\n    height: 100%;\r\n    width: 100%;\r\n    margin: 0;\r\n}\r\n\r\nbody>div {\r\n    display: none;\r\n    /* background-image: radial-gradient(circle farthest-side, #fceabb, #f8b500); */\r\n    /* background-image: radial-gradient(circle farthest-side, #ff512f, #f09819); */\r\n    /* color: black; */\r\n    /* font-family: Arial, Helvetica, sans-serif; */\r\n    /* background-color: white; */\r\n}\r\n\r\nbody,\r\nbutton {\r\n    background-color: black;\r\n    color: white;\r\n    font-family: 'Courier New', Courier, monospace;\r\n}\r\n\r\nheader span, button {\r\n    width: 6em;\r\n    padding: 1px 4px;\r\n}\r\n\r\nheader span {\r\n    font-size: 100px;\r\n    text-align: center;\r\n}\r\n\r\nbutton {\r\n    border: none;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n}\r\n\r\n.hover, button:hover {\r\n    font-weight: 900;\r\n}\r\n\r\nbutton:active {\r\n    transform: translate(1px, 1px);\r\n}\r\n\r\nheader button:last-child {\r\n    border: 1px solid white;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n}\r\n\r\nheader button:last-child:hover {\r\n    border: 2px solid white;\r\n}\r\n\r\nheader {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    align-items: center;\r\n    padding: 10px 0;\r\n    height:5em;\r\n}\r\n\r\ncanvas {\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: -1;\r\n    position: fixed;\r\n}\r\n\r\n.content {\r\n    margin: 0 5% 20px 5%;\r\n    border: 1px solid white;\r\n    padding: 2em;\r\n}\r\n\r\np {\r\n    line-height: 1.3;\r\n}\r\n\r\nli p {\r\n    margin-left: 3em;\r\n    margin-top: 0;\r\n}\r\n\r\nli div:first-child {\r\n    display: flex;\r\n    align-items: baseline;\r\n    gap: 1em;\r\n}\r\n\r\nli h3 {\r\n    margin-bottom: 0;\r\n    /* color: white; */\r\n}\r\n\r\n/* ul a:first-child {\r\n    color: white;\r\n} */\r\n\r\nul a {\r\n    color: #41FF00;\r\n}\r\n\r\ndiv:nth-of-type(1) li::marker {\r\n    color: white;\r\n\r\n}\r\n\r\nli div{\r\n    margin-bottom: 1em;\r\n}\r\n\r\ndiv:nth-of-type(2) ul {\r\n    list-style: none;\r\n}\r\n\r\n#copy {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-content: center;\r\n    background-color: transparent;\r\n    border-radius: 5px;\r\n    height: fit-content;\r\n    width: fit-content;\r\n}\r\n\r\n#copy img {\r\n    height: 1em;\r\n    width: 1em;\r\n}\r\n\r\ndiv:nth-of-type(2) li {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    height: 2em;\r\n    font-size: larger;\r\n}\r\n\r\nli span {\r\n    display: none;\r\n    font-style: italic;\r\n    font-weight: 300;\r\n} \r\n\r\ndiv:nth-of-type(3) p {\r\n    text-indent: 2em;\r\n}\r\n\r\n@media screen and (min-width: 500px) {\r\n    button {\r\n        font-size: 1.5em;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
